/* eslint-disable */
import numeral from 'numeral';

// ----------------------------------------------------------------------
function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  const format = number ? numeral(number).format('$0,0.00') : '';

  return result(format, '.00');
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

export function fCommaSeparated(num) {
  if(typeof num === 'string') {
    num = parseInt(num)
  }
  if (num) {
  return num.toLocaleString();
  }
  return 0;
}

export function fLargeNumber(num) {
  if (num === null || num === undefined || isNaN(num)) return '';

  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';

  const units = [
    { value: 1e12, suffix: 'T' },
    { value: 1e9, suffix: 'B' },
    { value: 1e6, suffix: 'M' },
    { value: 1e3, suffix: 'K' }
  ];

  for (const unit of units) {
    if (absNum >= unit.value) {
      const formatted = absNum / unit.value;
      const isRound = formatted % 1 === 0;
      return sign + (isRound ? formatted.toFixed(0) : formatted.toFixed(1)) + unit.suffix;
    }
  }

  return num.toString();
}
